<template>
  <v-dialog
    :model-value="isVisible"
    persistent
    width="300"
  >
    <v-card>
      <v-card-text class="pa-5">
        {{ label }}
        <v-progress-linear
          color="blue-grey-darken-2"
          indeterminate
          rounded
          height="6"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
defineProps<{
  isVisible: boolean;
  label: string;
}>();
</script>
